import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRepeat1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("mask", {
			id: "topGapMask",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 0,
				y: 0,
				width: 24,
				height: 24,
				fill: "white"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 8.25,
				y: 2.75,
				width: 7.5,
				height: 4.5,
				rx: 1.5,
				fill: "black"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			mask: "url(#topGapMask)",
			fill: "currentColor",
			d: "M5.00001 4C3.34315 4 2.00001 5.34314 2.00001 7L2 17C2 18.6569 3.34315 20 5 20H8C8.55228 20 9 19.5523 9 19C9 18.4477 8.55228 18 8 18H5C4.44771 18 4 17.5523 4 17V7C4 6.44772 4.44771 6 5 6L19 6C19.5523 6 20 6.44772 20 7L20 17C20 17.5523 19.5523 18 19 18H14.0027L15.2821 16.7161C15.6734 16.3235 15.6734 15.687 15.2821 15.2944C14.8909 14.9019 14.2566 14.9019 13.8654 15.2944L11.5937 17.574L11.5805 17.5873C10.804 18.3724 10.8057 19.6406 11.5859 20.4234L13.8604 22.7058C14.2513 23.0981 14.8852 23.0981 15.2762 22.7058C15.6672 22.3134 15.6672 21.6773 15.2762 21.285L13.9956 20H19C20.6569 20 22 18.6569 22 17L22 7C22 5.34315 20.6569 4 19 4H5.00001Z"
		}),
		/* @__PURE__ */ _jsx("text", {
			x: 12,
			y: .4,
			textAnchor: "middle",
			dominantBaseline: "text-before-edge",
			fontSize: 15,
			fontFamily: "Arial, Helvetica, sans-serif",
			fontWeight: "bold",
			fill: "currentColor",
			children: "1"
		})
	]
});
export default SvgRepeat1;
